/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'money-a-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M23.5 6H23v13a1 1 0 0 1-1 1H3v.5A1.502 1.502 0 0 0 4.5 22h19a1.502 1.502 0 0 0 1.5-1.5v-13A1.502 1.502 0 0 0 23.5 6z"/><path pid="1" d="M22 17.5v-13A1.502 1.502 0 0 0 20.5 3h-19A1.502 1.502 0 0 0 0 4.5v13A1.502 1.502 0 0 0 1.5 19h19a1.502 1.502 0 0 0 1.5-1.5zM4.5 17h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zm6.5-2c-1.654 0-3-1.794-3-4s1.346-4 3-4 3 1.794 3 4-1.346 4-3 4zm8.5-9h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"/>'
  }
})
